import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { boolBadge, boolToKey } from '@app/helpers/status.helper';
import { DecisionBadgeItem } from '@app/models/status.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DATE_FORMAT_LONG } from 'src/app/constant';

@Component({
  selector: 'app-decision-badge-list',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './decision-badge-list.component.html',
  styleUrl: './decision-badge-list.component.scss',
})
export class DecisionBadgeListComponent {
  @Input() title?: string;
  @Input() items: ReadonlyArray<DecisionBadgeItem> = [];
  @Input() completedAt: string | Date | null | undefined = null;
  readonly dateFormatLong = DATE_FORMAT_LONG;

  readonly boolBadge = boolBadge;
  readonly boolToKey = boolToKey;

  private translate = inject(TranslateService);

  trackById = (_: number, it: DecisionBadgeItem<string>) => it.id;
}
